import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { CpCompareSidebarCardsService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar-cards.service';
import { combineLatest, defer } from 'rxjs';

@Component({
  selector: 'app-cp-compare-room-heating-power-request',
  templateUrl: './cp-compare-room-heating-power-request.component.html',
  styleUrls: ['./cp-compare-room-heating-power-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareRoomHeatingPowerRequestComponent {

  @Input() id: string;

  private measureCards$ = defer(() => this.compareSidebarCardsService.roomMeasureTypeCards(this.id, EnumMeasureTypes.HEATING_POWER_REQUEST));

  viewModel$ = combineLatest({
    measureCards: this.measureCards$,
  });

  constructor(
    private compareSidebarCardsService: CpCompareSidebarCardsService
  ) {}

}
